var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"button",class:_vm.classNames,attrs:{"type":_vm.type,"disabled":_vm.disabled},on:{"click":function($event){$event.preventDefault();return _vm.$emit('eventClick')}}},[_c('span',[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }